module.exports = __webpack_public_path__ + "static/media/HB Gebäudereinigung Stadionbanner JPEG-Datei.2613b8b9.jpg";